import {
  userIdentificationExistingCartStart,
  userIdentificationStart,
} from "Store/userIdentification";
import {
  OperationType,
  UserIdentificationEntity,
} from "Store/userIdentification/userIdentificationInterfaces";
import { useDispatch, useSelector } from "react-redux";

import { useFeatureToggle } from "Store/featureToggles/featureToggleHooks";
import { FeatureToggle } from "Store/featureToggles/featureToggleTypes";
import { ReduxState } from "Store/rootReducer";
import { userIdentificationCheckExistingCartStart } from "Store/userIdentification/userIdentificationSlice";
import { loginIfNeeded } from "Utils/KeycloakWrapper";
import { getCartIdFromCookie } from "Utils/cookies/cookiesUtil";
import { isDefined } from "Utils/functions";
import { getProductEditQueryParams } from "Utils/navigation/queryParameterUtils";
import { useEffect } from "react";
import { ProductBackendName } from "./Products/productTypes";

export const useUserIdentification = (
  productBackendName: ProductBackendName,
): UserIdentificationEntity => {
  const { cartId: cartIdFromUrl, productId: productIdFromUrl } =
    getProductEditQueryParams();
  const cartIdFromCookie = getCartIdFromCookie();
  const { isAdvisor, cartId: advisorCartId } = useSelector(
    (state: ReduxState) => state.advisor,
  );
  const dispatch = useDispatch();
  const skiploginIfExistingCart = useFeatureToggle(
    FeatureToggle.SKIP_LOGIN_IF_EXISTING_CART,
  );
  const userIdentification = useSelector(
    (state: ReduxState) => state.userIdentification,
  );

  const setUserIdentificationFromExistingCart = (
    cartId: string,
    isCartIdFromCookie = false,
  ): void => {
    dispatch(
      userIdentificationExistingCartStart({
        cartId,
        cartIdFromCookie: isCartIdFromCookie,
      }),
    );
  };

  useEffect(() => {
    if (isDefined(userIdentification.current) || userIdentification.isLoading) {
      return;
    }

    if (isAdvisor && advisorCartId) {
      setUserIdentificationFromExistingCart(advisorCartId);
    } else if (cartIdFromUrl && productIdFromUrl) {
      setUserIdentificationFromExistingCart(cartIdFromUrl);
    } else if (cartIdFromCookie) {
      if (!skiploginIfExistingCart) {
        loginIfNeeded();
      }
      if (
        !(
          userIdentification.error &&
          userIdentification.error.operationType ===
            OperationType.GET_OFFER_FROM_ADVISOR_REQUEST
        )
      ) {
        dispatch(
          userIdentificationCheckExistingCartStart({
            cartId: cartIdFromCookie,
            products: productBackendName,
            cartIdFromCookie: true,
          }),
        );
      }
    } else {
      loginIfNeeded();
      dispatch(
        userIdentificationStart({
          products: productBackendName,
        }),
      );
    }
  }, [productBackendName]);

  return userIdentification;
};
